export default __webpack_public_path__ + "static/media/ve_3.77ef28ba.mp3";